import SectionHeading from '@/pages/home/components/SectionHeading';
import { downloadOptions } from '@/mocks/home';

export default function AppDownload() {
  return (
    <section id="download" className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-100 border-y border-background-200/70">
      <SectionHeading
        index="04"
        eyebrow="App Download"
        title="APP 下载 · 全端客户端说明"
        desc="不想每次都靠浏览器？按你的设备选择对应客户端。下面四种下载方式覆盖手机、电视与电脑，说明都写清了。"
      />

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-8 lg:gap-12 items-center">
        <div className="relative">
          <div className="w-full aspect-[4/3] rounded-lg overflow-hidden border border-background-300/70 bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Flat%20lay%20of%20a%20modern%20smartphone%20and%20tablet%20displaying%20a%20green%20apple%20streaming%20app%20interface%20on%20a%20warm%20off%20white%20studio%20background%20with%20soft%20natural%20shadows%2C%20minimal%20editorial%20product%20photography%2C%20muted%20green%20and%20cream%20palette&width=1200&height=900&seq=qpg-app-device&orientation=landscape"
              alt="青苹果影院 APP 客户端界面展示"
              title="青苹果影院 APP下载 客户端"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute bottom-4 left-4 bg-background-50 rounded-lg border border-background-200 px-4 py-3">
            <span className="font-label text-[11px] text-foreground-500">客户端版本</span>
            <span className="font-heading font-bold text-sm text-foreground-950 block">
              v3.2.0 · 2026-10
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {downloadOptions.map((item) => (
            <article
              key={item.id}
              className="flex flex-col p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-center justify-between mb-4">
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-2xl">
                  <i className={item.icon} aria-hidden="true"></i>
                </span>
                {item.badge && (
                  <span className="font-label text-[11px] px-2 py-1 rounded-full bg-accent-100 text-accent-800">
                    {item.badge}
                  </span>
                )}
              </div>
              <h3 className="font-heading font-bold text-base text-foreground-950">
                {item.title}
              </h3>
              <span className="font-label text-xs text-foreground-500 mt-0.5">
                {item.meta}
              </span>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">
                {item.desc}
              </p>
              <button
                type="button"
                className="mt-4 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md border border-primary-300 bg-primary-50 text-primary-700 font-label text-sm font-medium hover:bg-primary-500 hover:text-background-50 dark:hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-line" aria-hidden="true"></i>
                获取下载方式
              </button>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}